import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { getMarginBottomClass, marginBottomLevels } from '../../utils/marginBottom/index.js';
import omit from 'lodash/fp/omit';
import { Grid, Row, Cell } from '../Grid/Grid.js';
import { withScroll } from 'react-window-decorators';
import LogoHsbcGlobal from '../Logo/wrapped-logos/LogoHsbcGlobal.js';
import '../Logo/wrapped-logos/LogoHsbcHexagon.js';
import '../Logo/wrapped-logos/LogoHsbcUk.js';
import '../Logo/wrapped-logos/LogoHsbcAmanah.js';
import '../Logo/wrapped-logos/LogoMsGlobal.js';
import '../Logo/wrapped-logos/LogoHsbcJade.js';
import '../Logo/wrapped-logos/LogoHsbcExpat.js';
import styles from './masthead.css.js';
var Masthead = withScroll(function (_ref) {
  var _cn2;

  var children = _ref.children,
      _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'header' : _ref$component,
      logoSlot = _ref.logoSlot,
      _ref$marginBottom = _ref.marginBottom,
      marginBottom = _ref$marginBottom === void 0 ? 5 : _ref$marginBottom,
      scrollPositionY = _ref.scrollPositionY,
      _ref$sticky = _ref.sticky,
      sticky = _ref$sticky === void 0 ? false : _ref$sticky,
      rest = _objectWithoutProperties(_ref, ["children", "component", "logoSlot", "marginBottom", "scrollPositionY", "sticky"]);

  return React.createElement(Component, _extends({
    className: cn(_defineProperty({}, styles['Masthead--sticky'], sticky), getMarginBottomClass(marginBottom))
  }, omit(['scrollPosition', 'scrollPositionX'], rest)), React.createElement("div", {
    className: cn(styles.wrapper, (_cn2 = {}, _defineProperty(_cn2, styles['wrapper--sticky'], sticky), _defineProperty(_cn2, styles['wrapper--scrolled'], sticky && scrollPositionY > 0), _cn2))
  }, React.createElement(Grid, null, React.createElement(Row, null, children || React.createElement(Cell, {
    offsetLarge: 1,
    size: 12,
    sizeMedium: 12,
    sizeLarge: 10
  }, React.createElement("div", {
    className: styles.container
  }, logoSlot || React.createElement(LogoHsbcGlobal, null)))))));
});
Masthead.displayName = 'Masthead';
Masthead.propTypes = {
  children: PropTypes.node,
  component: PropTypes.string,
  logoSlot: PropTypes.node,

  /**
   * 0, 1, 2, 3, 4, 5, 6, 7
   */
  marginBottom: PropTypes.oneOf(marginBottomLevels),

  /** docgen-ignore */
  sticky: PropTypes.bool
};
export default Masthead;
export { Masthead };